/* eslint-disable jsx-a11y/anchor-is-valid */
import {SnackbarProvider, enqueueSnackbar} from 'notistack'
import {FC, useEffect, useState} from 'react'
import {Column} from 'react-table'
import Swal from 'sweetalert2'
import {ID, KTCard, KTSVG} from '../../../../../../../../_metronic/helpers'
import {
  KTable,
  KTableHeader,
  KTableLoading,
  KTableSelectionCellNonMultiple,
} from '../../../../../../components/UI'
import {KTableProvider, useKTable} from '../../../../../../contexts/KTableProvider'
import {useHoteleria} from '../../../../../../hooks/useHoteleria'
import {BookingDocumentModel} from '../../../../models/booking.model'
import {
  deleteBookingDocumentsService,
  getBookingDocumentService,
  getBookingDocumentServiceV,
  getBookingDocumentsService,
} from '../../../../services/booking.service'
import {ModalEditAttachmentDocuments} from '../Modals/ModalEditAttachmentDocuments'
import {getSnackBarToast} from '../../../../../../util/snackBar'

const TableAttachDocuments: FC = () => {
  const {data, setData, setPagination, loading, setLoading, pagination, selectedOn} = useKTable()
  const {currentTabItem, isAllowed} = useHoteleria()
  const [showModal, setShowModal] = useState(false)

  const handleNew = () => {
    setShowModal(true)
  }

  const getSnackBar = (message: string, variant: boolean) => {
    enqueueSnackbar(message, {
      variant: variant ? 'success' : 'error',
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'right',
      },
    })
  }

  const getAttachmentDocuments = async () => {
    setLoading(true)
    const {data: response} = await getBookingDocumentsService({
      ReservaId: currentTabItem.idToEdit,
      pageNumber: pagination.currentPage,
      size: pagination.perPage,
    })
    if (!response.error) {
      setData(response.data)
      setPagination({
        ...pagination,
        totalResults: response.total,
      })
    }
    setLoading(false)
  }

  const handleDelete = async () => {
    Swal.fire({
      title: '¿Estás seguro?',
      text: 'Al eliminar no podrás revertir esta acción',
      //showDenyButton: true,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, eliminar',
      confirmButtonColor: 'var(--kt-primary)',
      //denyButtonText: `Don't save`,
      cancelButtonText: 'No',
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
    })
      .then(async (result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          setLoading(true)
          const item = selectedOn.length > 0 ? selectedOn[0] : null
          if (item) {
            const {data: response} = await deleteBookingDocumentsService(item)
            if (!response.error) {
              getSnackBarToast('Se eliminó satisfactoriamente', 'success')
              getAttachmentDocuments()
            } else {
              getSnackBarToast(response.message, 'error')
            }
          }
          Swal.close()
        } else if (result.isDenied) {
          //Swal.fire('Changes are not saved', '', 'info')
        }
      })
      .catch(() => {})
  }

  const handleDownload = async (booking: BookingDocumentModel) => {
    try {
      const response = await getBookingDocumentServiceV(booking.Id)
      const contentType = response.headers['content-type'] || 'application/octet-stream'
      const blob = new Blob([response.data], {type: contentType})

      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `${booking.NombreDocumento}` // Ajusta el nombre del archivo según tus necesidades
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    } catch (error) {
      getSnackBarToast('Hubo un error', 'error')
    }
  }

  useEffect(() => {
    setLoading(loading)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])

  useEffect(() => {
    getAttachmentDocuments()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTabItem.idToEdit])

  useEffect(() => {
    setLoading(false)
    getAttachmentDocuments()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage])

  const columns: Column<BookingDocumentModel>[] = [
    {
      Header: (props) => <KTableHeader tableProps={props} />,
      id: 'selection',
      Cell: ({...props}) => <KTableSelectionCellNonMultiple id={props.data[props.row.index].Id} />,
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Nro de Documento' />,
      accessor: 'NumeroDocumento',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Nombre de Documento' />,
      accessor: 'NombreDocumento',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Tipo de Documento' />,
      accessor: 'TipoDocumento',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Tamaño de Documento' />,
      accessor: 'TamanoDocumento',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Fecha de Registro' />,
      accessor: 'FechaRegistro',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Usuario de Registro' />,
      accessor: 'UsuarioRegistro',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Ver' />,
      id: 'actions',
      Cell: ({...props}) =>
        isAllowed('ADJUNTARDOCUMENTOS/EDITAR') ? (
          <div
            className='d-flex justify-content-center flex-shrink-0'
            onClick={() => handleDownload(props.row.original)}
          >
            <a href='#' className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
              <KTSVG path='/media/icons/duotune/general/gen005.svg' className='svg-icon-3' />
            </a>
          </div>
        ) : (
          <></>
        ),
    },
  ]

  return (
    <>
      <KTCard shadow className='m-5'>
        <div className='d-flex justify-content-end p-2 me-5'>
          {isAllowed('ADJUNTARDOCUMENTOS/AGREGAR') && (
            <button type='button' className='btn btn-success me-3' onClick={handleNew}>
              Agregar
            </button>
          )}
          {isAllowed('ADJUNTARDOCUMENTOS/ELIMINAR') && (
            <button
              className='btn btn-primary me-3'
              disabled={selectedOn.length < 1}
              onClick={handleDelete}
              type='button'
            >
              Eliminar
            </button>
          )}
        </div>
        <KTable data={data} columns={columns} />
        {loading ? <KTableLoading title='Cargando...' /> : null}
        <ModalEditAttachmentDocuments
          show={showModal}
          setShow={setShowModal}
          getAttachmentDocuments={getAttachmentDocuments}
        />
        <SnackbarProvider />
      </KTCard>
    </>
  )
}

const TableAttachDocumentsWrapper = () => {
  const {isAllowed} = useHoteleria()
  return (
    <KTableProvider>
      {isAllowed('ADJUNTARDOCUMENTOS/LISTAR') && <TableAttachDocuments />}
    </KTableProvider>
  )
}

export {TableAttachDocumentsWrapper}
